import React, { Component } from 'react'
import type { Node } from 'react'
import Card from 'material-ui/Card'

type Props = {
  children: Node
}

class PageCard extends Component<Props> {
  render() {
    const {
      children
    } = this.props

    return (
      <Card className='center mw7 mv2'>
        {children}
      </Card>
    )
  }
}

export default PageCard



// WEBPACK FOOTER //
// ./src/components/PageCard/PageCard.js